import { apiSlice } from './apiSlice';
import { RingCentralClient } from 'app/shared-components/Types/RingCentralClient';
import { apiRoutes } from '@/app/apiConfig/apiRoutes';

export const ringCentralApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRingCentralAccounts: builder.query<RingCentralClient[], void>({
      query: () => ({
        url: `${apiRoutes.ringCentralClientIds}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetRingCentralAccountsQuery } = ringCentralApiSlice;
